import gql from 'graphql-tag';

export const CAMPAIGN_SAVED_TEMPLATE_FIELDS = gql`
  fragment CampaignSavedTemplateFields on CampaignPostMaloneSavedTemplateType {
    id
    campaignId
    ccaTemplateType
    postMaloneSavedTemplateId
    selectedAt
    categoryIds
    postMaloneSavedTemplate {
      id
      externalId
      publisherId
      name
      description
      templateType
      selectable
      inputs {
        name
        type
      }
      outputs {
        name
        contentType
      }
      fetchedAt
    }
  }
`;
